module.exports = __webpack_public_path__ + "static/media/buildingConstruction16.c879231e.jpeg";